import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Button from "@mui/material/Button";
import Icon from "@mui/material/Icon";
import TextField from "@mui/material/TextField";
import axios from "axios";
import ApiEndpoints from "components/Api";
import useLoading from "components/Loading";
import "./SongSelectModal.css";

const SongSelectModal = ({ open, onClose, onSelect, songsEndpoint }) => {
  const [songs, setSongs] = useState([]);
  const [filter, setFilter] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: "name", direction: "ascending" });
  const [showLoading, hideLoading, Loading] = useLoading();

  useEffect(() => {
    if (open) {
      fetchSongs();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const fetchSongs = async () => {
    try {
      const token = localStorage.getItem("authToken");
      showLoading();
      const url = songsEndpoint || ApiEndpoints.SONGS;
      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setSongs(response.data);
      hideLoading();
    } catch (e) {
      hideLoading();
    }
  };

  const requestSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  const sortedSongs = [...songs].sort((a, b) => {
    if (a[sortConfig.key] < b[sortConfig.key]) return sortConfig.direction === "ascending" ? -1 : 1;
    if (a[sortConfig.key] > b[sortConfig.key]) return sortConfig.direction === "ascending" ? 1 : -1;
    return 0;
  });

  const filteredSongs = sortedSongs.filter((song) => {
    if (filter === "") return true;
    const searchTerms = filter.toLowerCase().split(" ");
    return searchTerms.every((term) => {
      const inName = song.name.toLowerCase().includes(term);
      const inTags = (song.tags || []).some((tag) =>
        tag.name.toLowerCase().includes(term)
      );
      return inName || inTags;
    });
  });

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Wybierz pieśń</DialogTitle>
      <DialogContent>
        <Loading />
        <div className="song-select-filter">
          <TextField
            label="Filtruj"
            fullWidth
            margin="dense"
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
          />
        </div>
        <Table className="songs-table">
          <TableHead>
            <TableRow>
              <TableCell onClick={() => requestSort("name")}>Tytuł {sortConfig.key === "name" && (
                <Icon style={{ fontSize: "0.75rem", verticalAlign: "middle" }}>
                  {sortConfig.direction === "ascending" ? "arrow_upward" : "arrow_downward"}
                </Icon>
              )}</TableCell>
              <TableCell>Akcje</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredSongs.map((song) => (
              <TableRow key={song.id}>
                <TableCell>{song.name}</TableCell>
                <TableCell className="songs-modal-actions">
                  <div className="songs-modal-actions-container">
                    <Button color="success" variant="contained" size="small" onClick={() => onSelect(song)}>
                      Wybierz
                    </Button>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="success" variant="outlined">
          Zamknij
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SongSelectModal;
